<script setup>
/* global axios */
// Carteira de Cliente — PADRÃO DA CONTA. Cada caixa pode sobrescrever ativar/modo/
// auto-carteirizar (em Configurações da caixa → Colaboradores). Fallback e expiração
// ficam só aqui (offboarding e inatividade do contato são da conta inteira).
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const route = useRoute();
const base = `/api/v1/accounts/${route.params.accountId}/kanban`;

const cfg = ref({
  enabled: false,
  mode: 'priority',
  auto_assign: false,
  fallback_user_id: null,
  expiry_days: 0,
});
const agents = ref([]);
const saving = ref(false);

onMounted(async () => {
  try {
    const { data } = await axios.get(`${base}/carteira_config`);
    cfg.value = { ...cfg.value, ...(data.data || {}) };
  } catch (e) {
    /* mantém o default */
  }
  try {
    agents.value =
      (await axios.get(`/api/v1/accounts/${route.params.accountId}/agents`))
        .data || [];
  } catch (e) {
    agents.value = [];
  }
});

const salvar = async () => {
  saving.value = true;
  try {
    await axios.put(`${base}/carteira_config`, { carteira_config: cfg.value });
    useAlert('Configuração da carteira salva.');
  } catch (e) {
    useAlert('Não foi possível salvar a configuração da carteira.');
  } finally {
    saving.value = false;
  }
};
</script>

<template>
  <SectionLayout
    title="Carteira de Cliente"
    description="Direciona as conversas de um contato para o agente dono dele. Este é o padrão da conta; cada caixa pode sobrescrever em Configurações da caixa."
    with-border
  >
    <div class="flex flex-col gap-4 mt-2">
      <label class="flex items-center gap-2 text-sm text-n-slate-12">
        <input v-model="cfg.enabled" type="checkbox" />
        Ativar a carteira nesta conta
      </label>

      <div class="flex flex-col gap-1">
        <span class="text-sm font-medium text-n-slate-12">Modo</span>
        <select
          v-model="cfg.mode"
          class="w-full rounded-lg border border-n-weak bg-n-alpha-black2 px-3 py-2 text-sm"
        >
          <option value="priority">Prioridade (dono se estiver online)</option>
          <option value="direct">Direto (sempre o dono)</option>
        </select>
      </div>

      <label class="flex items-center gap-2 text-sm text-n-slate-12">
        <input v-model="cfg.auto_assign" type="checkbox" />
        Auto-carteirizar: o 1º atendente que assumir vira o dono
      </label>

      <div class="flex flex-col gap-1">
        <span class="text-sm font-medium text-n-slate-12">
          Gestor (fallback) — recebe as carteiras de um agente desativado
        </span>
        <select
          v-model="cfg.fallback_user_id"
          class="w-full rounded-lg border border-n-weak bg-n-alpha-black2 px-3 py-2 text-sm"
        >
          <option :value="null">Nenhum (volta para a fila)</option>
          <option v-for="a in agents" :key="a.id" :value="a.id">
            {{ a.name }}
          </option>
        </select>
      </div>

      <div class="flex flex-col gap-1">
        <span class="text-sm font-medium text-n-slate-12">
          Expira em (dias sem interação do dono — 0 = nunca)
        </span>
        <input
          v-model.number="cfg.expiry_days"
          type="number"
          min="0"
          class="w-32 rounded-lg border border-n-weak bg-n-alpha-black2 px-3 py-2 text-sm"
        />
      </div>

      <div>
        <NextButton blue :is-loading="saving" @click="salvar">
          Salvar
        </NextButton>
      </div>
    </div>
  </SectionLayout>
</template>
